module.exports = __webpack_public_path__ + "img/logo.f1fa0738.svg";